module.exports = __webpack_public_path__ + "img/藏品架起沟通的桥梁.6fb635d5.png";